import { IconButton } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { type ForwardedRef } from 'react'

import { noOp } from '@/utils/helpers'

const ToolbarButton = React.forwardRef(
  (
    {
      icon,
      active,
      onMouseDown = noOp,
      isDisabled = false,
    }: {
      icon: IconDefinition
      active: boolean
      onMouseDown?: (event: unknown) => void
      isDisabled?: boolean
    },
    ref: ForwardedRef<HTMLButtonElement>
  ) => (
    <IconButton
      ref={ref}
      aria-label="action"
      variant="icon"
      width="32px"
      h="32px"
      minWidth="unset"
      borderRadius="8px"
      textAlign="center"
      cursor="pointer"
      bg="bg"
      color={active ? 'primary.fg' : 'fg.muted'}
      _hover={{ bg: active ? 'primary.subtle' : 'bg.muted' }}
      onClick={event => {
        onMouseDown(event)
      }}
      icon={<FontAwesomeIcon icon={icon} />}
      isDisabled={isDisabled}
    />
  )
)

export default ToolbarButton
